import { createSlice } from "@reduxjs/toolkit";
import { getSaleReportData } from "./ThunkAction";
import { ProFormaInvoce } from "./Types";

const initialState: ProFormaInvoce = {
  productDetail: [],
  dataList: [], 
  loadingList: false, 
  loadingDataList: false, 
  message: null,
  error: null,
  loading: false
};

const saleReportSlice = createSlice({
  name: "saleReportState",
  initialState,
  reducers: {
    clearSaleReportData: (state) => {
      state.productDetail = [];
      state.loadingList = false;
      state.loadingDataList = false;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
       builder
      .addCase(getSaleReportData.pending, (state) => {
        state.loadingDataList = true;
        state.error = null;
      })
      .addCase(getSaleReportData.fulfilled, (state, action) => {
        state.loadingDataList = false;
        state.dataList = action.payload?.data || [];
        state.message = action.payload?.message || null;
      })
      .addCase(getSaleReportData.rejected, (state, action) => {
        state.loadingDataList = false;
        
        state.error = action.payload?.message || "Something went wrong";
      });
  },
});

export const { clearSaleReportData } = saleReportSlice.actions;
export default saleReportSlice.reducer;
